import { createDirtyChecker, compareByPaths } from "../../gvc/testNewForm/createDirtyChecker";
import { inputToServiceAccount } from "../utils";

export function getDirtyChecker(id: string) {
  return createDirtyChecker(id, inputToServiceAccount, compareByPaths({
    description: { path: "description" },
    tags: { path: "tags" },
  }));
}
